import React, { useCallback } from 'react';

import { Scenario } from '@queries/scenarios';
import Modal from '../../../shared/modals/modal.component';
import { BatchRemoveDetailsPayloadWithValue } from './types';

type DeleteDetailsModalComponentProps = {
  detailsToRemove: BatchRemoveDetailsPayloadWithValue[] | null,
  isVisible: boolean,
  isRemoving?: boolean,
  removeDetails: (detailsToRemove: BatchRemoveDetailsPayloadWithValue[]) => void,
  hideModal: () => void,
  isLoadingScenarios: boolean,
  scenarios: Partial<Record<string, Scenario>>
}

export const DeleteDetailsModalComponent = ({
  isVisible,
  isRemoving,
  detailsToRemove,
  removeDetails,
  hideModal,
  isLoadingScenarios,
  scenarios,
}: DeleteDetailsModalComponentProps) => {
  const remove = useCallback(() => {
    if (detailsToRemove) {
      removeDetails(detailsToRemove);
    }
  }, [removeDetails, detailsToRemove]);

  return (
    <Modal
      className="delete-obligations-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Details"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={remove}
      isVisible={isVisible}
      isLoading={isLoadingScenarios}
      isSubmitting={isRemoving}
    >
      <>
        <div> Are you sure you want to remove following details? <br/></div>
        {
          detailsToRemove?.map(({ companyCode, countryTaxType, scenarioId, value }) => (
            <div key={`${scenarioId}${companyCode}${countryTaxType}`}>
              <b>Scenario: </b> { scenarios?.[scenarioId]?.scenarioName ?? 'Loading...' } <br/>
              <b>Company Code: </b> {companyCode} <br/>
              <b>Country Tax Type: </b> {countryTaxType} <br/>
              <b>Value: </b> { value }
              <hr/>
            </div>
          ))
        }
      </>
    </Modal>
  );
};
